import "./index.css";

const TextTag = ({ text }) => {
  return <div className="text__tag">{text}</div>;
};

export default TextTag;
